
export function logInfo(message, variables) {
    //console.log(new Date() + " INFO " + message, variables);
}

export function logError(errorWhere, errorMessage, variables) {

}
